import httpClient from '../httpClient';

export const getProductList = async (
  category,
  brandId,
  storeId,
  idCustomer,
  keyword,
  subcategory,
  filterList,
  currPage = 1,
  perPage = 10,
  priceLev = '',
  sortBy = 'Position',
  urlKey = '',
  menuLevel = null,
  topSearch = false,
  signal = null,
  userId = null,
) => {
  const params = {
    category: category,
    brandId: brandId,
    storeId: storeId,
    idCustomer: idCustomer,
    keyword: keyword,
    subcategory: subcategory,
    filterList: filterList,
    currPage: currPage,
    perPage: perPage,
    priceLev: priceLev,
    sortBy: sortBy,
    urlKey: urlKey,
    menuLevel: menuLevel,
    topSearch: topSearch,
  };
  if (userId) {
    params.userId = userId;
  }

  console.log('API /product/get called with params:', params);
  console.log('Price Level being sent:', priceLev);

  const result = await httpClient.get('/product/get', { params, signal });

  return result.data;
};

export const getSearchPreviewList = async (
  keyword,
  idCustomer,
  brandId,
  idStore,
  priceLev = '',
  signal = null,
  userId = null,
) => {
  const params = {
    keyword: keyword,
    idCustomer: idCustomer,
    brandId: brandId,
    idStore: idStore,
    priceLev: priceLev,
  };
  if (userId) {
    params.userId = userId;
  }
  const result = await httpClient.get('/product/get-search-preview', {
    params,
    signal,
  });
  return result.data;
};

export const getProductDetail = async (
  idStyle,
  idCustomer,
  idStore,
  priceLev = '01',
  userId = null,
) => {
  const params = {
    idStyle: idStyle,
    idCustomer: idCustomer,
    idStore: idStore,
    priceLev: priceLev,
  };
  if (userId) {
    params.userId = userId;
  }
  const result = await httpClient.get('/product/get-detail', {
    params,
  });
  return result.data;
};

// Parent/Child Item: 같은 그룹의 size/diameter variant 목록
export const getGroupVariants = async (idStyle, idStore) => {
  const result = await httpClient.get('/product/get-group-variants', {
    params: {
      idStyle: idStyle,
      idStore: idStore,
    },
  });
  return result.data;
};

export const getRelatedProductList = async (
  idStyle,
  idCustomer,
  idStore,
  priceLev = '01',
) => {
  const result = await httpClient.get('/product/get-related', {
    params: {
      idStyle,
      idCustomer,
      idStore,
      priceLev: priceLev,
    },
  });
  return result.data;
};

export const getCrossProductList = async (
  idStyle,
  idCustomer,
  idStore,
  priceLev = '01',
) => {
  const result = await httpClient.get('/product/get-cross', {
    params: {
      idStyle,
      idCustomer,
      idStore,
      priceLev: priceLev,
    },
  });
  return result.data;
};

export const getItemUOMList = async (idStyle) => {
  const result = await httpClient.get('/product/get-uom', {
    params: {
      idStyle,
    },
  });
  return result.data;
};

export const getAllProductList = async () => {
  const result = await httpClient.get('/product/get-all');
  return result.data;
};

// Line Sheet 공유 링크 (Shoppable Link)
export const getLinesheetProducts = async (idLinesheet, idStore) => {
  const result = await httpClient.get('/product/get-by-linesheet', {
    params: {
      idLinesheet: idLinesheet,
      idStore: idStore,
    },
  });
  return result.data;
};

export const getProductListByColumn = async (
  columnName,
  idCustomer,
  brandId,
  priceLev = '',
) => {
  const result = await httpClient.get('/product/get-by-column', {
    params: {
      columnName: columnName,
      idCustomer: idCustomer,
      brandId: brandId,
      priceLev: priceLev,
    },
  });
  return result.data;
};

export const getProductSpecifications = async (
  idStyle,
  idCustomer,
  idStore,
) => {
  const result = await httpClient.get('/product/get-specifications', {
    params: {
      idStyle: idStyle,
      idCustomer: idCustomer,
      idStore: idStore,
    },
  });
  return result.data;
};

export const getProductImages = async (idStyle) => {
  const result = await httpClient.get('/product/get-images', {
    params: {
      idStyle: idStyle,
    },
  });
  return result.data;
};

export const getProductDescription = async (idStyle) => {
  const result = await httpClient.get('/product/get-description', {
    params: {
      idStyle: idStyle,
    },
  });
  return result.data;
};

export const getProductsByBrandTag = async (
  brandName,
  storeId,
  idCustomer,
  currPage = 1,
  perPage = 10,
  priceLev = '',
  sortBy = 'Position',
  signal = null,
) => {
  const result = await httpClient.get('/product/get-by-brand-tag', {
    params: {
      brandName: brandName,
      storeId: storeId,
      idCustomer: idCustomer,
      currPage: currPage,
      perPage: perPage,
      priceLev: priceLev,
      sortBy: sortBy,
    },
    signal: signal,
  });
  return result.data;
};

export const getProductByBarcode = async (
  barcode,
  brandId = 1,
  storeId = 1,
  idCustomer = 1,
  currPage = 1,
  perPage = 10,
  priceLev = '',
  sortBy = 'Position',
  signal = null,
) => {
  const result = await httpClient.get('/product/get-by-barcode', {
    params: {
      barcode: barcode,
      brandId: brandId,
      storeId: storeId,
      idCustomer: idCustomer,
      currPage: currPage,
      perPage: perPage,
      priceLev: priceLev,
      sortBy: sortBy,
    },
    signal: signal,
  });
  return result.data;
};

export const getProductBySku = async (
  sku,
  brandId = 1,
  storeId = 1,
  idCustomer = 1,
  currPage = 1,
  perPage = 10,
  priceLev = '',
  sortBy = 'Position',
  signal = null,
) => {
  const result = await httpClient.get('/product/get-by-sku', {
    params: {
      sku: sku,
      brandId: brandId,
      storeId: storeId,
      idCustomer: idCustomer,
      currPage: currPage,
      perPage: perPage,
      priceLev: priceLev,
      sortBy: sortBy,
    },
    signal: signal,
  });
  return result.data;
};

export const getProductByTitle = async (
  title,
  brandId = 1,
  storeId = 1,
  idCustomer = 1,
  currPage = 1,
  perPage = 10,
  priceLev = '',
  sortBy = 'Position',
  signal = null,
) => {
  const result = await httpClient.get('/product/get-by-title', {
    params: {
      title: title,
      brandId: brandId,
      storeId: storeId,
      idCustomer: idCustomer,
      currPage: currPage,
      perPage: perPage,
      priceLev: priceLev,
      sortBy: sortBy,
    },
    signal: signal,
  });
  return result.data;
};

export const getProductByShortDescription = async (
  shortDescr,
  brandId = 1,
  storeId = 1,
  idCustomer = 1,
  currPage = 1,
  perPage = 10,
  priceLev = '',
  sortBy = 'Position',
  signal = null,
) => {
  const result = await httpClient.get('/product/get-by-short-description', {
    params: {
      shortDescr: shortDescr,
      brandId: brandId,
      storeId: storeId,
      idCustomer: idCustomer,
      currPage: currPage,
      perPage: perPage,
      priceLev: priceLev,
      sortBy: sortBy,
    },
    signal: signal,
  });
  return result.data;
};

export const getProductByDetailedDescription = async (
  fullDescr,
  brandId = 1,
  storeId = 1,
  idCustomer = 1,
  currPage = 1,
  perPage = 10,
  priceLev = '',
  sortBy = 'Position',
  signal = null,
) => {
  const result = await httpClient.get('/product/get-by-detailed-description', {
    params: {
      fullDescr: fullDescr,
      brandId: brandId,
      storeId: storeId,
      idCustomer: idCustomer,
      currPage: currPage,
      perPage: perPage,
      priceLev: priceLev,
      sortBy: sortBy,
    },
    signal: signal,
  });
  return result.data;
};
